
import { defineComponent, PropType } from 'vue'
import { PackageManager } from '~/types/types'
import { getHumanizedTimeFromNow } from '~/utils/date'
import { getPackageManagerIcon, getTargetTitle } from '~/utils/dependencies'
import { getBackRoute } from '~/utils/router'

export default defineComponent({
  name: 'TargetHeader',
  props: {
    manifestPath: {
      type: String,
      default: ''
    },
    lockfilePath: {
      type: String,
      default: ''
    },
    packageManager: {
      type: String as PropType<PackageManager>,
      required: true
    },
    active: {
      type: Boolean,
      default: true
    },
    updated: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    backRoute() {
      return getBackRoute(this.$route)
    },
    activeClass() {
      return this.active ? ['text-juniper-9'] : ['text-cherry-500']
    },
    activeIconColor() {
      return this.active ? 'juniper-9' : 'cherry-500'
    },
    targetTitle() {
      return getTargetTitle(this.manifestPath, this.lockfilePath)
    },
    showLockfileDirectory() {
      return (
        this.lockfilePath &&
        this.targetTitle.lockfileDirectory !== this.targetTitle.manifestDirectory
      )
    },
    manifestTextColorClass() {
      return this.manifestPath ? 'text-vanilla-300' : ''
    },
    lockfileTextColorClass() {
      return this.lockfilePath ? (this.manifestPath ? 'text-vanilla-400' : 'text-vanilla-300') : ''
    }
  },
  methods: {
    getHumanizedTimeFromNow,
    getPackageManagerIcon
  }
})
